import { render, staticRenderFns } from "./CostBreakdownTable.vue?vue&type=template&id=f806e5c2&scoped=true&"
import script from "./CostBreakdownTable.vue?vue&type=script&lang=js&"
export * from "./CostBreakdownTable.vue?vue&type=script&lang=js&"
import style0 from "./CostBreakdownTable.vue?vue&type=style&index=0&id=f806e5c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f806e5c2",
  null
  
)

export default component.exports